module.exports = __webpack_public_path__ + "static/website-spa5-458e6981493279c7320f7582fe45ebbb.png";